import { CButton, CCol, CForm, CFormGroup, CInput, CInputGroup, CInputGroupAppend, CInputGroupText, CLabel, CRow, CSelect } from '@coreui/react'
import React, { useState } from 'react'
import { isValidEmail, Limpiar } from './Tools'
import { Icon } from '@iconify/react'
import { CustomSelect } from 'src/security/OTP'
import { RegisterCustomSelect } from './RegisterCustomSelect'
import AxiosManager from 'src/config/axiosManager'
import { provinciasRD } from './RegisterMunicipios'
import NumberFormat from 'react-number-format'
import { RegisterStepLeft } from './RegisterStepLeft'

export const RegisterStep2 = ({ DataForm, handleChange, setDataForm, onCancel, onSuccess }) => {
    const [consultando, setConsultando] = useState(false)
    const consultaRNC = async () => {
        setConsultando(true)
        AxiosManager.get("/rnc", { params: { q: DataForm.rnc } })
            .then(({ data }) => {
                console.log(data)
                setDataForm({
                    ...DataForm,
                    rnc: data.rnc,
                    nombre: data.nombre,
                    nombrecomercial: data.nombre
                });
            })
            .catch(() => { })
            .finally(() => setConsultando(false))
    };

    const md01 = 5;
    const md02 = 6;

    const valid = Limpiar(DataForm.nombre.toUpperCase()).length > 6
        && isValidEmail(DataForm.correo)
        && Limpiar(DataForm.telefono).length === 10
        && (DataForm.pais !== 1 || (DataForm.pais == 1 && DataForm.provincia.trim() !== 'Seleccione' && provinciasRD
            .filter(f => f.provincia === DataForm.provincia)[0].municipios
            .filter(p => p === DataForm.municipio)
            .length !== 0))

    return (
        <CRow>
            <RegisterStepLeft DataForm={DataForm} />
            <CCol xs="12" md="7">
                <div className="text-md-left ">
                    <h3 className="text-primary">
                        Informacion de la Cooperativa.
                    </h3>
                    <p>
                        Agradecemos completar la información solicitada de forma clara, precisa y verídica. Este formulario está dividido en dos secciones: Información de la Cooperativa e Información del Representante. Todos los campos marcados con asterisco (*) son obligatorios.
                    </p>
                    <p></p>
                </div>

                {DataForm.estado === 1 && <CRow>
                    <CCol xs="4">
                        <CLabel htmlFor="company"> R.N.C. :</CLabel>
                        <CInput
                            name="rnc"
                            value={DataForm.rnc}
                            onChange={handleChange}
                            onBlur={consultaRNC}
                            className={`mb-3 ${consultando ? "opaco cargando" : ""}`}
                            disabled
                        />
                    </CCol>
                    <CCol xs="5" md="4">
                        <CLabel htmlFor="company">  Fecha de constitucion :</CLabel>
                        <CInput
                            value={DataForm.constitucion}
                            placeholder="constitucion"
                            onChange={handleChange}
                            type='date'
                            name="constitucion"
                            className={`mb-3 ${consultando ? "opaco cargando" : ""}`}
                            disabled
                        />
                    </CCol>
                </CRow>
                }

                <CRow>
                    <CCol xs="12">
                        <CLabel htmlFor="company"> Nombre legal de la cooperativa :</CLabel>
                        <CInput
                            value={DataForm.nombre}
                            placeholder="nombre"
                            onChange={handleChange}
                            name="nombre"
                            className={`mb-3 ${consultando ? "opaco cargando" : ""}`}
                            style={{
                                borderColor: Limpiar(DataForm.nombre.toUpperCase()).length > 6 ? '' : "red",
                            }}
                        />
                    </CCol>
                    <CCol xs="12">
                        <CLabel htmlFor="company">  Nombre Comercial de la cooperativa :</CLabel>
                        <CInput
                            value={DataForm.nombrecomercial}
                            placeholder="nombrecomercial"
                            onChange={handleChange}
                            name="nombrecomercial"
                            className={`mb-3 ${consultando ? "opaco cargando" : ""}`}
                            style={{
                                borderColor: Limpiar(DataForm.nombrecomercial.toUpperCase()).length > 6 ? '' : "red",
                            }}
                        />
                    </CCol>


                    <CCol xs="6">
                        <CLabel htmlFor="company">  Telefono :</CLabel>

                        <NumberFormat
                            value={DataForm.telefono}
                            onChange={handleChange}
                            format="###-###-####"
                            mask="_"
                            name="telefono"
                            className={`form-control mb-3 ${consultando ? "opaco cargando" : ""}`}
                            style={{
                                borderColor: Limpiar(DataForm.telefono).length === 10 ? '' : "red",
                            }}
                        />
                    </CCol>
                    <CCol xs="6">
                        <CLabel htmlFor="company">  Correo :</CLabel>
                        <CInput
                            value={DataForm.correo}
                            placeholder="correo"
                            onChange={handleChange}
                            name="correo"
                            className={`mb-3 ${consultando ? "opaco cargando" : ""}`}
                            style={{
                                borderColor: isValidEmail(DataForm.correo) ? "" : "red",
                            }}
                        />
                    </CCol>
                    <CCol xs="12">
                        <CLabel htmlFor="company">  Direccion:</CLabel>
                        <CInput
                            value={DataForm.direccion}
                            placeholder="direccion"
                            onChange={handleChange}
                            name="direccion"
                            className={`mb-3 ${consultando ? "opaco cargando" : ""}`}
                        />
                    </CCol>

                    {DataForm.pais === 1 && <CCol xs="6">
                        <CLabel htmlFor="company">  Provincia :</CLabel>
                        <CSelect
                            className="mb-3"
                            aria-label="Large select example"
                            value={DataForm.provincia}
                            name="provincia"
                            onChange={handleChange}
                            style={
                                DataForm.provincia.trim() === 'Seleccione'
                                    ? { borderColor: "red" }
                                    : {}
                            }
                        >
                            {provinciasRD
                                .map((row) => (
                                    <option value={row.provincia}>
                                        {" "}
                                        {row.provincia}{" "}
                                    </option>
                                ))}
                        </CSelect>
                    </CCol>}
                    {DataForm.pais === 1 && <CCol xs="6">
                        <CLabel htmlFor="company">  Municipio :</CLabel>
                        <CSelect
                            className="mb-3"
                            aria-label="Large select example"
                            value={DataForm.municipio}
                            name="municipio"
                            onChange={handleChange}
                            style={
                                provinciasRD
                                    .filter(f => f.provincia === DataForm.provincia)[0].municipios
                                    .filter(p => p === DataForm.municipio)
                                    .length === 0
                                    ? { borderColor: "red" }
                                    : {}
                            }
                        >
                            <option value="Seleccione">Seleccione</option>
                            {provinciasRD
                                .filter(f => f.provincia === DataForm.provincia)[0].municipios
                                .map((row) => (
                                    <option value={row}>
                                        {" "}
                                        {row}{" "}
                                    </option>
                                ))}
                        </CSelect>
                    </CCol>
                    }

                </CRow>



                <div
                    className="row justify-content-center"
                    style={{ flexFlow: "row", paddingTop: 100 }}
                >
                    <CButton
                        type="submit"
                        style={{ background: 'red', height: 60, padding: 0, margin: 0 }}
                        className="btn-block LoginInput2"
                        onClick={onCancel}
                    >
                        <Icon icon="icon-park-twotone:back" width={25} /> Atras
                    </CButton>
                    <CButton
                        type="submit"
                        color="primary"
                        style={{ height: 60, padding: 0, margin: 0 }}
                        className="btn-block LoginInput2"
                        disabled={!valid}
                        onClick={onSuccess}
                    >

                        Siguiente
                        <Icon icon="fluent:presence-available-10-regular" width={25} style={{ marginLeft: 10 }} />
                    </CButton>
                </div>
            </CCol>
        </CRow>
    )
}
